export const AUTH_SIGN_IN = '/auth/login';
